import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import './common/styles/index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);